// Theses will be executed on the client side at root level

export const loadPolyfills = () => {
	if (!String.prototype.replaceAll) {
		String.prototype.replaceAll = function (search, replace) {
			return this.split(search).join(replace);
		};
	}

	if (!Array.prototype.flatMap) {
		Array.prototype.flatMap = function (lambda) {
			return Array.prototype.concat.apply([], this.map(lambda));
		};
	}
};
